// src/modules/config/components/MenuItemModal/BasicInfoTab.tsx
import React from 'react';
import { Form, Input, Select, Row, Col } from 'antd';
import { MenuCategory } from '@/types';

const { TextArea } = Input;

interface BasicInfoTabProps {
  categories: MenuCategory[];
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({
  categories,
  onNameChange
}) => {
  return (
    <div>
      {/* Основная информация на русском, казахском и английском */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="name"
            label="Название (русский)"
            rules={[{ required: true, message: 'Введите название блюда' }]}
          >
            <Input 
              placeholder="Название блюда на русском" 
              onChange={onNameChange}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="name_kz"
            label="Название (казахский)"
          >
            <Input placeholder="Название блюда на казахском" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="name_en"
            label="Название (английский)"
          >
            <Input placeholder="Dish name in English" />
          </Form.Item>
        </Col>
      </Row>

      {/* Артикул и Slug */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="article"
            label="Артикул"
            rules={[{ required: true, message: 'Введите артикул' }]}
          >
            <Input placeholder="ART-12345" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="slug"
            label="URL (slug)"
            rules={[{ required: true, message: 'Введите slug' }]}
          >
            <Input placeholder="url-friendly-name" />
          </Form.Item>
        </Col>
      </Row>

      {/* Категории */}
      <Form.Item
        name="category"
        label="Категории"
        rules={[{ required: true, message: 'Выберите хотя бы одну категорию' }]}
      >
        <Select 
          mode="multiple" 
          placeholder="Выберите категории"
          showSearch
          allowClear
          maxTagCount="responsive"
          optionFilterProp="label"
          options={categories.map(category => ({
            key: category.id,
            label: category.parent ? `— ${category.name}` : category.name,
            value: category.id
          }))}
          filterOption={(input, option) =>
            (option?.label as string).toLowerCase().includes(input.toLowerCase())
          }
          tagRender={(props) => {
            const { label, closable, onClose } = props;
            const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
              event.preventDefault();
              event.stopPropagation();
            };
            return (
              <span
                onMouseDown={onPreventMouseDown}
                style={{
                  marginRight: 3,
                  padding: '2px 7px',
                  border: '1px solid #d9d9d9',
                  borderRadius: 6,
                  background: '#fafafa',
                  fontSize: '12px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  lineHeight: '20px',
                }}
              >
                {label}
                {closable && (
                  <span
                    style={{
                      marginLeft: 5,
                      cursor: 'pointer',
                      color: '#999',
                    }}
                    onClick={onClose}
                  >
                    ×
                  </span>
                )}
              </span>
            );
          }}
        />
      </Form.Item>
      
      {/* Описание */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="description"
            label="Описание (русский)"
          >
            <TextArea rows={4} placeholder="Описание блюда на русском" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="description_kz"
            label="Описание (казахский)"
          >
            <TextArea rows={4} placeholder="Описание блюда на казахском" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="description_en"
            label="Описание (английский)"
          >
            <TextArea rows={4} placeholder="Dish description in English" />
          </Form.Item>
        </Col>
      </Row>
      
      {/* Состав */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="composition"
            label="Состав (русский)"
            rules={[{ required: true, message: 'Введите состав блюда' }]}
          >
            <TextArea rows={4} placeholder="Состав блюда на русском" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="composition_kz"
            label="Состав (казахский)"
          >
            <TextArea rows={4} placeholder="Состав блюда на казахском" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="composition_en"
            label="Состав (английский)"
          >
            <TextArea rows={4} placeholder="Dish composition in English" />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};